import { Component, ViewChild, ElementRef, OnInit, OnDestroy, AfterViewInit, HostListener, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";

import { WorkspaceDetailBaseComponent, FileDetailBaseComponent } from "@mypxplat/xplat/features";
import { UserService, HelperService, WorkspaceService, WindowService, environment, EventBusService, BaseComponent, CommunityService, Notification, NotificationService } from "@mypxplat/xplat/core";
import { AngularFirestoreCollection, AngularFirestore, AngularFirestoreDocument } from "@angular/fire/compat/firestore";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { AppService, FirebaseService, WebCommunityService } from "@mypxplat/xplat/web/core";
import { CreatePublicLinkComponent, EditCommentComponent } from "../modals";
import { take, filter, map, takeUntil } from "rxjs/operators";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { ChatComponent } from "../chat/chat.component";
import { MessageInputComponent } from "../message-input/message-input.component";
import { ClipboardService } from "ngx-clipboard";
import { WaveformCommentsComponent } from "../waveform-comments/waveform-comments.component";
import { triggerFileDownload } from "../../../utils/download-file";
import moment from "moment";
import { File } from "@mypxplat/xplat/core";
declare var window: any;

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-file-detail",
  templateUrl: "file-detail.component.html",
  standalone: false,
})
export class FileDetailComponent extends FileDetailBaseComponent implements OnInit, OnDestroy {
  public timelineRef: AngularFirestoreDocument<any>;
  public parentThreadMap: any;
  public fileThreadRef: AngularFirestoreDocument;
  public fileThreadsRef: AngularFirestoreCollection;
  public fileThreadMessagesRef: AngularFirestoreCollection;
  public smallestFile: File;
  public loadingFileThreadMessages: boolean = true;
  public fileThreadMessagesSubscription: any;
  public fileThreadMessages: Array<any>;
  public fileThreadMessage: string;
  public missedTimelineMessagesRef: AngularFirestoreCollection;
  public missedFileThreadMessagesRef: AngularFirestoreCollection;
  public firestore: AngularFirestoreCollection;
  public messagesRef: AngularFirestoreCollection;
  public messagesSubscription: any;
  public routerEvents: any;
  public collaboratorMap: any = {};
  public messageDeleteIndex: number;
  public chatViewHeight: any = 100;
  public attingCollabs: Array<any>;
  public highlightedAtCollab: any;
  public selectedAtCollab: any;
  public selectedAtCollabsInMessage: any = {};
  public newMsg: string;
  public collaborators: Array<any>;
  public uiReady: boolean = false;
  public isPlaying: boolean = false;
  public timecodes: Array<any>;
  public fileSections: Array<any>;
  public truncatedFileSections: Array<any>;
  public displayedFileSection: any;
  public env = environment;
  public copied: boolean = false;
  public shouldShowPublicLinkButton: boolean = false;
  public fileThreadConversationID: string;

  public isWorkspaceOwner: boolean = false;
  public selectingStemFile: boolean;

  @ViewChild("addAudioCommentEl", { static: false }) addAudioCommentEl: ElementRef;
  @ViewChild("chatCmp") chatCmp: ChatComponent;
  @ViewChild("messageInputCmp", { static: false }) messageInputCmp: MessageInputComponent;
  @ViewChild("audioCommentReplyInput", { static: false }) audioCommentReplyInput: MessageInputComponent;
  @ViewChild("waveformCommentScroll", { static: false }) waveformCommentScroll: ElementRef;
  @ViewChild("waveformComments", { static: false }) waveformComments: WaveformCommentsComponent;

  @Output() workspaceLoaded: EventEmitter<any> = new EventEmitter();

  @ViewChild("chatWindow", { static: false }) chatWindow: ElementRef;
  @ViewChild("chatView", { static: false }) chatView: ElementRef;
  @ViewChild("descTextSpan", { static: false }) descTextSpan: ElementRef;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _clipboardService: ClipboardService,
    private _win: WindowService,
    private _eventbusService: EventBusService,
    public workspaceService: WorkspaceService,
    public userService: UserService,
    public helperService: HelperService,
    public communityService: WebCommunityService,
    public appService: AppService,
    public db: AngularFirestore,
    public fbAuth: AngularFireAuth,
    public router: Router,
    public fbService: FirebaseService,
    private notificationService: NotificationService
  ) {
    super(userService, workspaceService);
  }

  ngOnInit() {
    this.initView(this._activatedRoute.snapshot.params["id"]);
    this.routerEvents = this.router.events.subscribe((result) => {
      // this allows you to "navigate" to another file detail from this page
      if (result instanceof NavigationEnd) {
        this.initView(this._activatedRoute.snapshot.params["id"]);
      }
    });

    this._eventbusService.observe(this._eventbusService.types.playAudio).subscribe((result) => {
      this.measureUI();
    });
  }

  initView(id) {
    this.loading = true;
    // need to make sure the user is authenticated with firebase before setting up the firestore subscriptions.

    const go = () => {
      this.workspaceService.getFileDetails(id).subscribe({
        next: (result) => {
          this.file = result;
          if (this.file.workspace_id) {
            this.workspaceService.getWorkspace(this.file.workspace_id).subscribe((result) => {
              this.isWorkspaceOwner = result.user_id == this.userService.user.id;
            });
          }
          if (this.file.formats && this.file.formats.length && this.file.formats.length > 1) {
            // choose the smallest format to play.
            let size: any = false;
            this.file.formats.forEach((file) => {
              if (!this.smallestFile) this.smallestFile = file;
              if (!size) size = parseInt(file.filesize);
              if (parseInt(file.filesize) < size) {
                size = parseInt(file.filesize);
                this.smallestFile = file;
              }
            });
            this.smallestFile.workspace = this.file.workspace;
          }
          this.checkPublicLinkAvailability();
          let parts = this.file.filename.split(".");
          let nameNoExtension = "";
          parts.forEach((item, index) => {
            if (index != parts.length - 1) nameNoExtension += item;
          });
          if (this.file.type != "folder") this.file.name_no_extension = nameNoExtension;
          if (this.file.public_link && moment(this.file.public_link.expiration_date) < moment()) {
            this.file.public_link.expired = true;
          }
          if (this.file.formats && this.file.formats.length) {
            this.file.formats.forEach((item) => {
              if (item.public_link && moment(item.public_link.expiration_date) < moment()) {
                item.public_link.expired = true;
              }
            });
          }
          this.collabsNotMe = [];
          this.file.workspace.collaborators.forEach((item) => {
            if (item.user_id != this.user.id && item.status === "approved") {
              this.collabsNotMe.push({
                id: item.user_id,
                name: item.name,
                photo: item.photo,
                email: item.email,
              });
            }
            this.collaboratorMap[item.user_id] = item;
          });
          if (this.workspaceService.audioFiles[this.file.extension]) {
            this.fileSections = [{ name: "File Discussion" }, { name: "Timestamped Comments", selected: true }, { name: "File Details" }];
            this.truncatedFileSections = [{ name: "Timestamped Comments", selected: true }, { name: "File Details" }];
            this.displayedFileSection = "Timestamped Comments";
          } else {
            this.fileSections = [{ name: "File Discussion", selected: true }, { name: "File Details" }];
          }
          let file;
          if (this._activatedRoute.snapshot.params["fileid"] && this.file.grouped_files && this.file.grouped_files.length)
            file = this.file.grouped_files.filter((item) => item.id == this._activatedRoute.snapshot.params["fileid"])[0];
          if (!file) file = this.file;
          this.initFileView(file);
          this._win.setTimeout(() => {
            this.measureUI();
            this.uiReady = true;
          }, 50);
        },
        error: (error) => {
          this.appService.alertError(error);
          this.router.navigate(["workspaces"]);
        },
      });
    };
    window.scrollTo(0, 0);
    go();
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.measureUI();
  }

  checkPublicLinkAvailability() {
    this.shouldShowPublicLinkButton = false;
    if (this.file.formats && this.file.formats.length > 1) {
      this.file.formats.forEach((item) => {
        if (!item.public_link) this.shouldShowPublicLinkButton = true;
      });
    } else if (this.waveformComments && !this.waveformComments.selectedWaveformFile.public_link) {
      this.shouldShowPublicLinkButton = true;
    } else if (!this.file.public_link) {
      this.shouldShowPublicLinkButton = true;
    }
  }

  initFileView(file) {
    this.loading = false;
    this.timelineRef = this.fbService.doc(`timelines/${this.file.workspace.firebase_timeline_id}`);
    this.fileThreadsRef = this.fbService.collection(`timelines/${this.file.workspace.firebase_timeline_id}/fileThreads`);
    this.fileThreadConversationID = this.file.id.toString();
    if (file.type == "stems" && file.grouping_id) {
      this.fileThreadConversationID = file.grouping_id;
    } else if (file.format_grouping_id) {
      this.fileThreadConversationID = file.format_grouping_id;
    }
    this.fileThreadRef = this.fbService.doc(`timelines/${this.file.workspace.firebase_timeline_id}/fileThreads/${this.fileThreadConversationID}`);
    this.fbService
      .handleFirestorePromise(() => this.fbService.doc(`timelines/${this.file.workspace.firebase_timeline_id}/fileThreads/${this.fileThreadConversationID}`).ref.get())
      .then((documentSnapshot) => {
        if (!documentSnapshot.exists) {
          this.fbService
            .doc(`timelines/${this.file.workspace.firebase_timeline_id}/fileThreads/${this.fileThreadConversationID}`)
            .set({
              created: new Date(),
              file_id: this.file.id,
              created_by: this.user.id,
            })
            .then((doc) => {
              this.fileThreadMessagesRef = this.fbService.collection(`timelines/${this.file.workspace.firebase_timeline_id}/fileThreads/${this.fileThreadConversationID}/messages`, (ref) => {
                return ref.orderBy("created");
              });
              this.initMessages();
            });
        } else {
          this.fileThreadMessagesRef = this.fbService.collection(`timelines/${this.file.workspace.firebase_timeline_id}/fileThreads/${this.fileThreadConversationID}/messages`, (ref) => {
            return ref.orderBy("created");
          });
          this.initMessages();
        }
      });
  }

  showImage(src) {
    this._eventbusService.emit(this._eventbusService.types.viewFullscreenImage, src);
  }

  public screenWidth: number;
  measureUI() {
    this.screenWidth = window.innerWidth;
    if (this.chatView && this.chatView.nativeElement) {
      let offsetTop = this.chatView.nativeElement.getBoundingClientRect().y;
      const height = window.innerHeight - offsetTop;
      let body = document.getElementsByTagName("body")[0];
      this.chatViewHeight = height - 30;
    }
    if (this.file) {
      if (this.screenWidth > 767 && this.workspaceService.audioFiles[this.file.extension] && this.displayedFileSection == "File Discussion") {
        this.displayedFileSection = "Timestamped Comments";
      } else if (!this.workspaceService.audioFiles[this.file.extension]) {
        this.displayedFileSection = "File Discussion";
      }
      this.fileSections.forEach((section) => (section.selected = section.name == this.displayedFileSection));
      if (this.truncatedFileSections) this.truncatedFileSections.forEach((section) => (section.selected = section.name == this.displayedFileSection));
    }
  }

  initMessages() {
    this.fileThreadMessages = [];
    this.missedFileThreadMessagesRef = this.fbService.collection(`timelines/${this.file.workspace.firebase_timeline_id}/fileThreads/${this.fileThreadConversationID}/missedMessages`);
    this.missedTimelineMessagesRef = this.fbService.collection(`timelines/${this.file.workspace.firebase_timeline_id}/missedMessages`);

    this.communityService
      .subscribeToComments(this.fileThreadMessagesRef, "asc")
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (result) => {
          this.loadingFileThreadMessages = false;
          this.updateMyReadStatus();
          if (this.chatCmp && this.chatCmp.scrollChatToBottom) this.chatCmp.scrollChatToBottom();
        },
        (error) => {}
      );
  }

  incrementUnreadCount() {
    this.file.workspace.collaborators.forEach((item) => {
      if (item.user_id && item.user_id != this.userService.user.id) {
        const userFileThreadMissedRef = this.fbService.doc(`timelines/${this.file.workspace.firebase_timeline_id}/fileThreads/${this.fileThreadConversationID}/missedMessages/${item.user_id}`);
        userFileThreadMissedRef.get().subscribe((result: any) => {
          if (!result.data()) {
            userFileThreadMissedRef.set({
              missedCount: 1,
            });
          } else {
            let count = result.data().missedCount;
            userFileThreadMissedRef.set({
              missedCount: ++count,
            });
          }
        });
        const userTimelineMissedRef = this.fbService.doc(`timelines/${this.file.workspace.firebase_timeline_id}/missedMessages/${item.user_id}`);
        userTimelineMissedRef.get().subscribe((result: any) => {
          if (!result.data()) {
            userTimelineMissedRef.set({
              missedCount: 1,
            });
          } else {
            let count = result.data().missedCount;
            userTimelineMissedRef.set({
              missedCount: ++count,
            });
          }
        });
      }
    });
  }

  updateMyReadStatus() {
    this.timelineRef.get().subscribe((result) => {
      let readStatus = result.data().readStatus;
      if (!readStatus) readStatus = Object.assign({}, result.data().contributors);
      readStatus[this.user.id] = true;
      let count = Object.entries(readStatus).length;
      let caughtUpCount = 0;
      let caughtUp = false;
      for (var i in readStatus) {
        if (readStatus[i]) {
          caughtUpCount++;
        }
      }
      if (caughtUpCount == count) caughtUp = true;
      const update = { readStatus, caughtUp };
      this.timelineRef.update(update);
    });
    this.fbService.doc(`timelines/${this.file.workspace.firebase_timeline_id}/fileThreads/${this.fileThreadConversationID}/missedMessages/${this.userService.user.id}`).set({
      missedCount: 0,
    });
  }

  addMessage(args) {
    this.newMsg = args.message;
    let obj: any = {
      author: {
        id: this.user.id,
        photo: this.user.photoURL,
        name: this.user.firstName + " " + this.user.lastName,
      },
      user_id: this.user.id,
      file_id: this.file.id,
      type: "message",
      workspace_name: this.file.workspace.name,
      timestamp: new Date(),
      created: new Date(),
    };

    // Mentions resolve last: finalizeMessage measures its character offsets
    // against the string it returns.
    const finalized = this.chatCmp.msgInput.finalizeMessage(this.newMsg);
    this.newMsg = finalized.message;
    if (finalized.mentions.length) obj.mentions = finalized.mentions;
    this.chatCmp.msgInput.selectedMentionsInMessage = [];

    obj.message = this.newMsg;
    this.fileThreadMessagesRef.add(obj);
    this.incrementUnreadCount();
    this.timelineRef.get().subscribe((result) => {
      let readStatus = result.data().readStatus;
      if (!readStatus) readStatus = Object.assign({}, result.data().contributors);
      for (var i in readStatus) {
        readStatus[i] = i == this.user.id ? true : false;
      }

      this.timelineRef.update({ readStatus });
    });
    let notification = this.notificationService.createCollaborationMessage("collaboration_file_new_message", this.user, this.newMsg, this.file.workspace, this.file);
    if (this.collabsNotMe.length) {
      let notMentionIds = [];
      this.collabsNotMe.forEach((collab) => {
        if (!obj.mentions || !obj.mentions.length) {
          notMentionIds.push(collab.id);
        } else {
          // only add the id to the notMentionIds array if its not present in the mentions array
          let found = false;
          obj.mentions.forEach((mention) => {
            if (mention.id == collab.id) found = true;
          });
          if (!found) notMentionIds.push(collab.id);
        }
      });
      if (notMentionIds.length) {
        // send the notification to users who were not mentioned, users who were mentioned should also get an email
        this.notificationService
          .sendNotification({
            notification: notification,
            user_ids: notMentionIds,
            clients: ["rollup", "mobile"],
          })
          .subscribe();
      }
    }
    if (obj.mentions && obj.mentions.length) {
      // send the notification to users who were mentioned, and include "email" in clients array
      let mentionIds = [];
      obj.mentions.forEach((mention) => {
        mentionIds.push(mention.id);
      });
      notification.title = this.user.firstName + " mentioned you in " + this.file.workspace.name;
      this.notificationService
        .sendNotification({
          notification: notification,
          user_ids: mentionIds,
          clients: ["rollup", "mobile", "email"],
        })
        .subscribe();
    }
  }

  downloadFile() {
    if (this.file.formats && this.file.formats.length > 1) {
      let args: any = {
        title: "Which format would you like to download?",
        actions: [],
      };
      this.file.formats.forEach((item) => {
        args.actions.push(item.extension.toUpperCase());
      });
      this._eventbusService.emit(this._eventbusService.types.showActionChooser, args);
      this._eventbusService
        .observe(this._eventbusService.types.actionChosen)
        .pipe(take(1))
        .subscribe((result) => {
          if (result) {
            this.file.formats.forEach((item) => {
              if (item.extension.toUpperCase() == result) {
                triggerFileDownload(item.url, item.filename);
              }
            });
          }
        });
    } else {
      const file = this.waveformComments && this.waveformComments.selectedWaveformFile ? this.waveformComments.selectedWaveformFile : this.file;
      triggerFileDownload(file.url, file.filename);
    }
  }

  msgOptions(msg) {
    let args: any = {
      title: msg.message,
      actions: ["Edit Message", "Delete Message"],
    };
    this._eventbusService.emit(this._eventbusService.types.showActionChooser, args);
    this._eventbusService
      .observe(this._eventbusService.types.actionChosen)
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          if (result == "Edit Message") {
            this.editMsg(msg);
          } else if (result == "Delete Message") {
            this.deleteMsg(msg);
          }
        }
      });
  }

  editMsg(msg) {
    const modalRef = this.appService.showModal(EditCommentComponent, { size: "lg" });
    modalRef.componentInstance.comment = { ...msg };
    modalRef.componentInstance.isHtmlComment = true;
    modalRef.componentInstance.collaborators = this.collabsNotMe;
    modalRef.result.then((result) => {
      let updateItem = this.communityService.comments.filter((item) => item.key == msg.key)[0];
      let updateData: any = { message: result.message, edited: true };
      if (result.mentions) updateData.mentions = result.mentions;
      this.fbService.doc(`timelines/${this.file.workspace.firebase_timeline_id}/fileThreads/${this.fileThreadConversationID}/messages/${updateItem.key}`).update(updateData);
    });
  }

  deleteMsg(msg) {
    if (confirm("Are you sure you want to remove this message? This cannot be undone.")) {
      this.fileThreadMessages.forEach((item, index) => {
        if (msg.key == item.key) this.messageDeleteIndex = index;
      });
      this.fbService.doc(`timelines/${this.file.workspace.firebase_timeline_id}/fileThreads/${this.fileThreadConversationID}/messages/${msg.key}`).delete();
    }
  }

  playAudio(file) {
    this._eventbusService.emit(this._eventbusService.types.playAudio, file);
  }

  markAsMainMix(file) {
    this.workspaceService.updateFile({ id: file.id, mainmix: true }).subscribe((result) => {
      // this.refreshFiles();
    });
  }

  inlineCommentHoverEnter(comment) {
    this.waveformComments.hoveringComment = comment;
  }

  inlineCommentHoverLeave(comment) {
    this.waveformComments.hoveringComment = undefined;
  }

  downloadStems() {
    let files = this.file.grouped_files;
    let timeout = 0;
    files.forEach((item) => {
      timeout += 500;
      item.delay = timeout;
    });
    files.forEach((file) => {
      this._win.setTimeout(() => {
        triggerFileDownload(file.url, file.filename);
      }, file.delay);
    });
  }

  createPublicLink() {
    if (this.file.formats && this.file.formats.length > 1) {
      let args: any = {
        title: "Which format would you like to share?",
        actions: [],
      };
      this.file.formats.forEach((item) => {
        if (!item.public_link) args.actions.push(item.extension.toUpperCase());
      });
      this._eventbusService.emit(this._eventbusService.types.showActionChooser, args);
      this._eventbusService
        .observe(this._eventbusService.types.actionChosen)
        .pipe(take(1))
        .subscribe((result) => {
          if (result) {
            this.file.formats.forEach((item) => {
              if (item.extension.toUpperCase() == result) {
                const modalRef = this.appService.showModal(CreatePublicLinkComponent, { size: "am" });
                modalRef.componentInstance.file = item;
                modalRef.result.then(
                  (data) => {
                    if (data) item.public_link = data;
                    this.checkPublicLinkAvailability();
                  },
                  (error) => {}
                );
              }
            });
          }
        });
    } else {
      const modalRef = this.appService.showModal(CreatePublicLinkComponent, { size: "am" });
      modalRef.componentInstance.file = this.waveformComments ? this.waveformComments.selectedWaveformFile : this.file;
      modalRef.result.then(
        (data) => {
          if (data) this.waveformComments ? (this.waveformComments.selectedWaveformFile.public_link = data) : (this.file.public_link = data);
          this.checkPublicLinkAvailability();
        },
        (error) => {}
      );
    }
  }

  togglePublicLinkComments(file?) {
    if (!file) file = this.file;
    let args = {
      id: file.public_link.id,
      show_comments: !file.public_link.show_comments,
    };
    file.public_link.show_comments = args.show_comments;
    this.workspaceService.updatePublicLink(args).subscribe((result) => {});
  }

  renewPublicLink(file?) {
    if (!file) file = this.file;
    let args = {
      id: file.public_link.id,
      expiration_date: moment().add(7, "days").toDate(),
    };
    this.workspaceService.updatePublicLink(args).subscribe((result: any) => {
      file.public_link.expiration_date = result.expiration_date;
      file.public_link.expired = false;
    });
  }

  copyLink(link) {
    this.copied = true;
    this._clipboardService.copy(link);
    this._win.setTimeout(() => {
      this.copied = false;
    }, 2500);
  }

  deletePublicLink(file?) {
    if (!file) file = this.file;
    this.workspaceService.deletePublicLink(file.public_link.id).subscribe((result) => {
      delete file.public_link;
    });
  }

  shareInCommunity() {
    this.communityService.attachingExistingFile = this.file;
    this.router.navigate(["community/channels/general"]);
  }

  sharePublicLinkInCommunity(hash) {
    this.communityService.attachingPublicFileLink = this.env.fenderUrl + "share/" + hash;
    this.router.navigate(["community/channels/general"]);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.communityService.comments = [];
    if (this.routerEvents && this.routerEvents.unsubscribe) this.routerEvents.unsubscribe();
  }
}
